import BaseService from "../../services/BaseService";
import TransactionService from "../../services/TransactionService";

export default {
    state: {
        transactions: [],
        balances: [],
        activeTransaction: {
            date: new Date().toISOString().substr(0, 10),
            period: new Date().toISOString().substr(0, 7),
            from_account_id: '',
            to_account_id: '',
            transaction_category_id: '',
            amount: '',
            description: '',
            type: 'expense',
        },
        dialog: false,
        isEdit: false,
    },
    getters: {
        transactions: state => {
            return state.transactions;
        },
        balances: state => {
            return state.balances;
        },
        activeTransaction: state => {
            return state.activeTransaction;
        },
        dialog: state => {
            return state.dialog;
        },
        isEdit: state => {
            return state.isEdit;
        },
    },
    mutations: {
        SET_TRANSACTIONS(state, transactions) {
            state.transactions = transactions;
        },
        SET_BALANCES(state, balances) {
            state.balances = balances;
        },
        SET_DIALOG(state, dialog) {
            state.dialog = dialog;
        },
        SET_IS_EDIT(state, isEdit) {
            state.isEdit = isEdit;
        },
        SET_ACTIVE_ITEM(state, activeItem) {
            state.activeTransaction = activeItem;
        },
    },
    actions: {
        setDialog( { commit }, value) {
            commit('SET_DIALOG', value);
        },
        setIsEdit( { commit }, value) {
            commit('SET_IS_EDIT', value);
        },
        setActiveItem( { commit }, activeItem) {
            commit('SET_ACTIVE_ITEM', activeItem);
        },
        loadTransactions( { state, commit }, filter) {
            if (filter || !state.transactions.length) {
                TransactionService.index(filter).then((result) => {
                    if (result.status === BaseService.STATUS_200) {
                        commit('SET_TRANSACTIONS', result.data);
                    }
                });
            }
        },
        loadBalances( { commit }, filter) {
            if (filter) {
                TransactionService.balances(filter).then((result) => {
                    if (result.status === BaseService.STATUS_200) {
                        commit('SET_BALANCES', result.data);
                    }
                });
            }
        },
        // eslint-disable-next-line no-unused-vars
        getDashboardTransactions( { state },id) {
            return TransactionService.getDashboardTransactions(id).then((result) => {
                return result.data;
            });
        },
        createTransaction( { dispatch }, data) {
            return TransactionService.createTransaction(data).then((result) => {
                if (result.status === BaseService.STATUS_200) {
                    dispatch('loadTransactions', true);
                    dispatch('loadAccounts', true);
                }
            });
        },
        updateTransaction( { dispatch }, params) {
            return TransactionService.updateTransaction(params.id, params.data).then((result) => {
                if (result.status === BaseService.STATUS_200) {
                    dispatch('loadTransactions', true);
                    dispatch('loadAccounts', true);
                }
            });
        },
        deleteTransaction( { dispatch }, id) {
            return TransactionService.deleteTransaction(id).then((result) => {
                if (result.status === BaseService.STATUS_200) {
                    dispatch('loadTransactions', true);
                    dispatch('loadAccounts', true);
                }
            });
        }
    },
}